exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".link-external {\n  text-align: right;\n  margin: 5px 0; }\n\n.description-main {\n  display: flex;\n  align-items: center; }\n\n.list {\n  list-style-type: square; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Portfolio/Item/index.scss
// module id = 968
// module chunks = 0